import React, { useState, useRef, useEffect } from 'react';

const RichTooltip = ({ children, content, width = 320 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [pos, setPos] = useState({ above: true, alignRight: false });
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (isVisible && triggerRef.current && tooltipRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      setPos({
        above: triggerRect.top > tooltipRect.height + 12,
        alignRight: triggerRect.left + width > window.innerWidth - 16,
      });
    }
  }, [isVisible, width]);

  return (
    <div
      ref={triggerRef}
      className="relative inline-flex"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && content && (
        <div
          ref={tooltipRef}
          className={`absolute z-50 ${pos.above ? 'bottom-full mb-2' : 'top-full mt-2'}
                      ${pos.alignRight ? 'right-0' : 'left-1/2 -translate-x-1/2'}
                      bg-gray-900 dark:bg-gray-800 text-white rounded-xl border border-gray-700 dark:border-gray-600
                      shadow-2xl p-4 pointer-events-none`}
          style={{ width }}
          role="tooltip"
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default RichTooltip;
